import { memo } from 'react';
import { Global } from '@emotion/react';
import tw, { GlobalStyles as BaseStyles, css } from 'twin.macro';
import 'react-toastify/dist/ReactToastify.css';

import tailwindConfig from '../../tailwind.config';

const customStyles = css`
  @font-face {
    font-family: 'Inter-Fallback';
    size-adjust: 104.18%;
    src: local('Arial');
  }

  @font-face {
    font-family: 'Poppins-Fallback';
    size-adjust: 103.25%;
    src: local('Arial');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    src:
      url('/fonts/inter/inter-variable.woff2') format('woff2 supports variations'),
      url('/fonts/inter/inter-variable.woff2') format('woff2-variations'),
      url('/fonts/inter/inter-variable.ttf') format('ttf supports variations');
    font-weight: 100 900;
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    font-style: italic;
    src:
      url('/fonts/inter/inter-italic-variable.woff2') format('woff2 supports variations'),
      url('/fonts/inter/inter-italic-variable.woff2') format('woff2-variations'),
      url('/fonts/inter/inter-italic-variable.ttf') format('ttf supports variations');
    font-weight: 100 900;
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: ${tailwindConfig.theme.fontWeight.light};
    src:
      url('/fonts/poppins/poppins-light.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-light.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-light.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: ${tailwindConfig.theme.fontWeight.light};
    src:
      url('/fonts/poppins/poppins-light-italic.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-light-italic.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-light-italic.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: ${tailwindConfig.theme.fontWeight.regular};
    src:
      url('/fonts/poppins/poppins-regular.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-regular.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-regular.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: ${tailwindConfig.theme.fontWeight.regular};
    src:
      url('/fonts/poppins/poppins-italic.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-italic.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-italic.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: ${tailwindConfig.theme.fontWeight.medium};
    src:
      url('/fonts/poppins/poppins-medium.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-medium.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-medium.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: ${tailwindConfig.theme.fontWeight.medium};
    src:
      url('/fonts/poppins/poppins-medium-italic.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-medium-italic.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-medium-italic.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: ${tailwindConfig.theme.fontWeight['semi-bold']};
    src:
      url('/fonts/poppins/poppins-semibold.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-semibold.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-semibold.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: ${tailwindConfig.theme.fontWeight['semi-bold']};
    src:
      url('/fonts/poppins/poppins-semibold-italic.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-semibold-italic.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-semibold-italic.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: ${tailwindConfig.theme.fontWeight.bold};
    src:
      url('/fonts/poppins/poppins-bold.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-bold.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-bold.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: ${tailwindConfig.theme.fontWeight.bold};
    src:
      url('/fonts/poppins/poppins-bold-italic.woff2') format('woff2 supports variations'),
      url('/fonts/poppins/poppins-bold-italic.woff2') format('woff2-variations'),
      url('/fonts/poppins/poppins-bold-italic.ttf') format('ttf supports variations');
    text-rendering: optimizeLegibility;
    font-display: swap;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    scroll-padding-top: 80px;
  }

  body {
    ${tw`font-poppins antialiased leading-5`};
    -webkit-tap-highlight-color: transparent;
  }

  * {
    box-sizing: border-box;
  }

  [data-codename][id] {
    scroll-margin-top: 100px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${tw`font-poppins`};
  }

  pre,
  code {
    font-family:
      ui-monospace, SFMono-regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
      monospace;
  }

  button {
    background: none;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    padding: 0;
  }

  .u-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .u-scroll-forbid {
    inset: 0px;
    height: 100%;
    margin: 0px;
    overflow-y: hidden;
    position: fixed;
  }

  [data-rmiz-btn-unzoom] {
    ${tw`bg-primary-p1`}
  }

  :root {
    --toastify-color-info: ${tailwindConfig.theme.colors.secondary.s1};
    --toastify-color-success: ${tailwindConfig.theme.colors.secondary.s1};
    --toastify-color-error: ${tailwindConfig.theme.colors.primary.p2};
    --toastify-toast-width: 448px;
    --toastify-font-family: 'Inter', sans-serif;
    --toastify-text-color-info: ${tailwindConfig.theme.colors.primary.p1};
    --toastify-text-color-success: ${tailwindConfig.theme.colors.primary.p1};
    --toastify-text-color-warning: ${tailwindConfig.theme.colors.primary.p1};
    --toastify-text-color-error: ${tailwindConfig.theme.colors.primary.p1};
  }
  .Toastify__toast {
    padding: 15px;
  }
  .Toastify__toast-body {
    font-weight: 500;
    padding-bottom: 20px;
  }
  .Toastify__progress-bar {
    bottom: 15px;
    margin: 0 20px;
    width: calc(100% - 40px);
  }
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
  .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
    ${tw`bg-primary-p1`}
  }
  .Toastify__close-button {
    ${tw`text-primary-p1`}
  }
`;

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <Global styles={customStyles} />
  </>
);

export default memo(GlobalStyles);
